import React from 'react';
import CompanyItem from "../Atoms/Items/CompanyItem";
import AddButton from "../Atoms/Buttons/AddButton";

const CompanySelector = () => {
  return (
    <div className="company-selector select-none float-container s-absolute">
      <div className="ed-grid full row-gap gap-1">
        <CompanyItem
          src="https://cdn.svgporn.com/logos/discord-icon.svg"
          companyName="Discord"
          className="is-active hover-change s-pxy-8px small-radius cursor-pointer"
        />
        <CompanyItem
          src="https://cdn.svgporn.com/logos/twitch.svg"
          companyName="Twitch"
          className="hover-change s-pxy-8px small-radius cursor-pointer"
        />
        <AddButton onClick={() => {}}
          text="Nueva empresa"/>
      </div>
    </div>
  );
};

export default CompanySelector;
